import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTourData, type TourActivityItem } from '../data/tour-data';

type Filter = 'ALL' | TourActivityItem['category'];
const filters: Array<{ value: Filter; label: string }> = [
  { value: 'ALL', label: 'All' }, { value: 'DOCUMENTS', label: 'Documents' }, { value: 'CONVERSATIONS', label: 'Conversations' }, { value: 'INVESTIGATIONS', label: 'Investigations' }, { value: 'INTELLIGENCE', label: 'Intelligence' },
];

export function TourActivityPage() {
  const fixture = useTourData();
  const [filter, setFilter] = useState<Filter>('ALL');
  const groups = useMemo(() => {
    const visible = filter === 'ALL' ? fixture.activity : fixture.activity.filter((item) => item.category === filter);
    const map = new Map<string, TourActivityItem[]>();
    for (const item of visible) {
      const key = new Date(item.occurred_at).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
      map.set(key, [...(map.get(key) ?? []), item]);
    }
    return [...map.entries()];
  }, [filter, fixture.activity]);

  return (
    <main className="r42-activity-page r42-tour-activity-page">
      <header className="r42-activity-header"><div><span className="r42-eyebrow">Machine history</span><h1>Activity</h1><p>Meaningful evidence, conversation, investigation, and memory changes for this example machine.</p></div></header>
      <div className="r42-activity-filters" aria-label="Activity filters">{filters.map((item) => <button key={item.value} type="button" className={filter === item.value ? 'is-active' : ''} aria-pressed={filter === item.value} onClick={() => setFilter(item.value)}>{item.label}</button>)}</div>

      <div className="r42-activity-timeline" data-tour-target="activity-timeline">
        {groups.map(([date, items]) => (
          <section key={date} className="r42-activity-day"><h2>{date}</h2><div className="r42-activity-list">
            {items.map((item) => <div key={item.activity_id} className="r42-activity-row"><span className="r42-activity-icon"><i className={`bi ${iconFor(item)}`} /></span><span className="r42-activity-copy"><span className="r42-activity-row-head"><strong>{item.title}</strong><time>{new Date(item.occurred_at).toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })}</time></span><span>{item.summary}</span></span></div>)}
          </div></section>
        ))}
      </div>

      <section className="r42-tour-completion-card"><i className="bi bi-check-circle" /><div><span className="r42-eyebrow">The Route42 loop</span><h2>Evidence becomes understanding that keeps accumulating.</h2><p>Add evidence. Ask questions. Investigate what matters. Let Machine Memory grow with what your team learns.</p><div><Link className="btn r42-btn-primary" to="/tour/machine">Explore again</Link><Link className="btn btn-outline-secondary" to="/machines">Return to my machines</Link></div></div></section>
    </main>
  );
}

function iconFor(item: TourActivityItem): string {
  if (item.event_type.startsWith('IMAGE_EVIDENCE_')) return 'bi-file-earmark-image';
  if (item.category === 'DOCUMENTS') return 'bi-file-earmark-text';
  if (item.category === 'CONVERSATIONS') return 'bi-chat-left-text';
  if (item.category === 'INVESTIGATIONS') return 'bi-search';
  return 'bi-cpu';
}
